import { createRequest } from "helpers/tools";

export const logOut = async () => {
    return await createRequest({
        suffix: `logout`,
        method: "post",
        payload: {},
        handleError: false,
    });
};
